module.exports = __webpack_public_path__ + "img/green-hairy-grass-03.e9ee42a3.png";